import React from 'react';
import { Link } from 'react-router-dom';

const AdvisoryBoard = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-light text-black mb-6 sm:mb-8 tracking-tight leading-tight px-2">
              Advisory Board
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
              At Sonom Performance Institute, we believe true success extends beyond athletic achievement—it's about 
              developing the whole person. Our Advisory Board brings together leaders in sports performance, athlete 
              wellness, education, and mental resilience.
            </p>
          </div>
        </div>
      </section>

      {/* Advisory Board Members */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
            
            {/* Doug Whaley */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Doug.Whaley.PNG"
                    alt="Doug Whaley"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'center top' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Doug Whaley</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  Beautiful Game Group, LLC
                </p>
              </div>
            </div>

            {/* Jim Monos */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Jim.Monos.PNG"
                    alt="Jim Monos"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Jim Monos</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3">
                  Study the Stats, LLC
                </p>
                <a
                  href="https://youtu.be/uGv6Bf1shM8?si=ahIgzmCRSqSQdG6j"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-spi-600 hover:text-spi-700 font-medium text-sm transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                  Watch Video
                </a>
              </div>
            </div>

            {/* Justin King */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Justin.King.png"
                    alt="Justin King"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Justin King</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3">
                  L.I.G. Sports Group
                </p>
                <a
                  href="https://youtu.be/xCkIYZM9afq"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-spi-600 hover:text-spi-700 font-medium text-sm transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                  Watch Video
                </a>
              </div>
            </div>

            {/* Laura Bixler */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Laura.Bixler.png"
                    alt="Laura Bixler"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Laura Bixler</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3">
                  Penn State Health
                </p>
                <a
                  href="https://youtu.be/nt0TflIYxAY?si=kcg4QgGPNKlCoAZj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-spi-600 hover:text-spi-700 font-medium text-sm transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                  Watch Video
                </a>
              </div>
            </div>

            {/* Michael Susi */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Mike.Susi.png"
                    alt="Michael Susi"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Michael Susi</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3">
                  Director of Global Wellness, LinkedIn
                </p>
                <a
                  href="https://youtu.be/Yv-BCj9e0sI?si=TygoSeogtxHdVpkk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-spi-600 hover:text-spi-700 font-medium text-sm transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                  Watch Video
                </a>
              </div>
            </div>

            {/* Elvin Atwine */}
            <div className="group">
              <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300 text-center">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 rounded-xl overflow-hidden bg-gray-100">
                  <img 
                    src="/assets/Elvin.Altwinet.png"
                    alt="Elvin Atwine"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-black mb-3">Elvin Atwine</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  Founder & CEO at Klorah
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* What to Expect - Mobile Optimized Grid */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-light text-black mb-8 sm:mb-12 text-center px-2">What to expect from our advisory board</h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-medium text-black mb-2">Sports Performance Experts</h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Elite coaches and trainers with proven track records in developing championship athletes.
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-medium text-black mb-2">Wellness Advocates</h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Mental health professionals and wellness experts focused on holistic athlete development.
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-medium text-black mb-2">Education Leaders</h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Academic professionals specializing in student-athlete education and NCAA compliance.
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-medium text-black mb-2">Innovation Specialists</h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Technology and research experts driving the future of athletic performance and education.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action - Mobile Optimized */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-light text-black mb-4 sm:mb-6 px-2">
            Stay updated on our progress
          </h2>
          <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Get notified when we announce our Advisory Board members and program developments.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-md sm:max-w-none mx-auto">
            <a 
              href="mailto:sonom.advantage@gmail.com" 
              className="bg-black hover:bg-gray-800 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-medium transition-colors duration-200 text-sm sm:text-base text-center"
            >
              Contact Us
            </a>
            <Link 
              to="/research-2026"
              className="border border-black text-black hover:bg-black hover:text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-medium transition-colors duration-200 text-sm sm:text-base text-center"
            >
              <span className="block sm:inline">Learn More</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AdvisoryBoard;